import type { ReactNode } from "react";

interface ToolbarProps {
  left: ReactNode;
  right?: ReactNode;
}

export const Toolbar = ({ left, right }: ToolbarProps) => (
  <div className="flex items-center justify-between gap-2">
    <div className="flex min-w-0 items-center gap-2">{left}</div>
    {right && <div className="flex shrink-0 items-center gap-2">{right}</div>}
  </div>
);
